import { FC, useMemo } from "react"
import { Button, ButtonProps, useTheme } from "@mui/material"

import { NearMeIcon } from "components/icons"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"

interface IStartButtonProps extends ButtonProps {
  label?: string
}

export const StartButton: FC<IStartButtonProps> = ({
  label = "Start",
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const icon = useMemo(
    () => getIcon(theme?.assets?.navigation?.start) || <NearMeIcon />,
    [theme]
  )

  return (
    <Button variant="contained" startIcon={icon} {...props}>
      {t(label)}
    </Button>
  )
}
